import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { FileStack, LogOut, ArrowLeft } from 'lucide-react';
import { clearAuth } from '../api/client';

export const PortalShell = ({ children, onSignOut }) => {
  const { pathname } = useLocation();
  const handleSignOut = () => {
    clearAuth();
    if (onSignOut) onSignOut();
  };
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <header className="border-b border-slate-800 bg-slate-900/60 backdrop-blur sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link
              to="/portal/evidence"
              className="flex items-center gap-2 group"
              data-testid="portal-home-link"
            >
              <FileStack className="w-5 h-5 text-emerald-400" />
              <div>
                <div className="text-sm font-semibold tracking-tight">Evidence Portal</div>
                <div className="text-[11px] uppercase tracking-widest text-slate-500 -mt-0.5">
                  Energy Performance Direct
                </div>
              </div>
            </Link>
            <Link
              to="/admin"
              data-testid="portal-back-to-admin"
              className="hidden md:inline-flex items-center gap-1 text-[11px] text-slate-500 hover:text-emerald-300 border-l border-slate-800 pl-4 py-1"
            >
              <ArrowLeft className="w-3 h-3" />
              Back to Admin
            </Link>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden md:inline text-xs text-slate-500 font-mono">{pathname}</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleSignOut}
              data-testid="portal-signout-btn"
              className="text-slate-400 hover:text-slate-100 hover:bg-slate-800"
            >
              <LogOut className="w-4 h-4 mr-1" />
              Sign out
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-8">{children}</main>
    </div>
  );
};
